export const ALL_POSTS = [
  {
    tags: ["context"],
    title: "How you structure context is how you structure behavior",
    excerpt:
      "Most agent failures in production aren't model failures. They're context failures – the wrong info, in the wrong form, at the wrong time. Most teams spend their energy on the prompt. Everything around it is architecture.",
    date: "Apr 2026",
    readTime: "4 min",
    slug: "how-you-structure-context-is-how-you-structure-behavior",
    nextSlug: "your-context-window-is-full-now-what",
    featured: true,
  },
  {
    tags: ["observability", "evals"],
    title: "Evals tell you what you designed for. Data tells you the rest.",
    excerpt:
      "The best signal you have on whether an LLM feature is working isn't your eval suite – it's your production data. Here's how tracing, eventing, and actually reviewing your data separates teams that improve from teams that drift.",
    date: "Apr 2026",
    readTime: "4 min",
    slug: "evals-tell-you-what-you-designed-for-data-tells-you-the-rest",
    nextSlug: "what-is-your-eval-suite-actually-measuring",
    featured: true,
  },
  {
    tags: ["craft"],
    title: "Shipping AI-assisted code without the slop",
    excerpt:
      "Slop isn't code that fails to compile. It's code that looks correct on the surface but isn't – written by a model with confidence, never read closely enough by the author. Here's how I avoid it while still letting the model do the work.",
    date: "Mar 2026",
    readTime: "3 min",
    slug: "shipping-ai-assisted-code-without-the-slop",
    nextSlug: "writing-code-got-faster-making-sure-it-works-didnt",
    featured: true,
  },
  {
    tags: ["evals"],
    title: "What is your eval suite actually measuring?",
    excerpt:
      "I've shipped features where the eval suite was green and the feature was still wrong. Not because the model failed – because I never specified what right looked like before I started measuring for it.",
    date: "Feb 2026",
    readTime: "5 min",
    slug: "what-is-your-eval-suite-actually-measuring",
    nextSlug: "evals-tell-you-what-you-designed-for-data-tells-you-the-rest",
    featured: false,
  },
  {
    tags: ["context"],
    title: "Your context window is full. Now what?",
    excerpt:
      "Every long-running agent hits the same limit eventually. Performance degrades as history accumulates, well before you hit it. There are a handful of approaches that work in practice – the right one depends on what you're building.",
    date: "Feb 2026",
    readTime: "5 min",
    slug: "your-context-window-is-full-now-what",
    nextSlug: "how-you-structure-context-is-how-you-structure-behavior",
    featured: false,
  },
  {
    tags: ["craft"],
    title: "Writing code got faster. Making sure it works didn't.",
    excerpt:
      "AI tools have drastically reduced the cost of writing code – but the cost of verifying it hasn't moved. Here's how I have the agent draft the QA plan, run it in the browser, and document findings while I'm already on the next thing.",
    date: "Jan 2026",
    readTime: "2 min",
    slug: "writing-code-got-faster-making-sure-it-works-didnt",
    nextSlug: "shipping-ai-assisted-code-without-the-slop",
    featured: false,
  },
];
